<template>
    <div>
        <Modal
            v-model="visible"
            :title="formData.id ? '编辑' : '新增'"
            :closable="true"
            :mask-closable="false"
            width="950"
            :footer-hide="true"
            class="my-modal top import-tool-modal2"
        >
            <Form ref="formInline" class="page-form" :model="formData" :rules="formDataValidate" :label-width="80">
                <FormItem label="姓名" prop="name" :rules="$units.formRule.required('请输入')">
                    <Input type="text" v-model="formData.name" placeholder="请输入" clearable />
                </FormItem>
                <FormItem label="证件类型" prop="cardType">
                    <Select v-model="formData.cardType" placeholder="请选择" filterable clearable transfer>
                        <Option :value="item.value" v-for="(item, index) in cardTypeList" :key="index">
                            {{ item.txt }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="证件号" prop="cardNo" :rules="$units.formRule.required('请输入')">
                    <Input type="text" v-model="formData.cardNo" placeholder="请输入" clearable />
                </FormItem>
                <FormItem label="职业类别" prop="jobGrade">
                    <Input type="text" v-model="formData.jobGrade" placeholder="请输入" clearable />
                </FormItem>

                <FormItem label="职业名称" prop="jobName">
                    <Input type="text" v-model="formData.jobName" placeholder="请输入" clearable />
                </FormItem>
                <FormItem label="职业编码" prop="jobCode">
                    <Input type="text" v-model="formData.jobCode" placeholder="请输入" clearable />
                </FormItem>
                
                <FormItem label="保障计划" prop="planName">         
                    <Input type="text" v-model="formData.planName" placeholder="请输入" clearable />
                </FormItem>
            </Form>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save" :loading="loading">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            policyNo:'',
            visible: false,
            loading: false,
            formDataValidate: {},
            jobGradeList: [
                {
                    value: '0',
                    label: '类别1'
                },
                {
                    value: '0',
                    label: '类别1'
                }
            ],
            formData: {
                name: '',
                cardNo: '',
                jobGrade: '',
                planName: ''
            },
            cardTypeList:[]
        };
    },
    methods: {
        open(data, policyNo) {
            const formData = JSON.parse(JSON.stringify(data));
            this.getCardTypeList();            
            this.policyNo = policyNo;
            this.formData = formData;
            this.formData.cardType = '01';
            this.visible = true;
        },

        getCardTypeList() {
            this.$http({
                url: "/system/dic/read/dicList",
                type: "post",
                data: {
                code: "CARD_TYPE"
                }
            }).then(res=>{
                this.cardTypeList = res.data;
            })
        },

        save() {
            this.$refs.formInline.validate().then(isok => {
                if (!isok) {
                    return;
                }
                this.loading = true;
                const formData = JSON.parse(JSON.stringify(this.formData));
                const data = {
                    insureList:[formData],
                    policyNo: this.policyNo
                }
                this.$http({
                    url: '/buz/grouppolicy/enter/insures/saveOrUpdate',
                    type: 'POST',
                    data
                }).then(res => {
                    this.visible = false; 
                    this.loading = false;                                       
                    this.$notice.success(formData.id ? '修改成功' : '新增成功');
                    this.$emit('success');
                }).catch((e)=>{
                    this.loading = false;
                });
            });
        }
    }
};
</script>

<style lang="less"></style>
